<template>
  <div class="exerciseDetail">
    <template v-if="online">
      <Header @backFn="backFn" :isXue="isXue" :isApp="isApp" v-if="isLogin">
        <template #timer v-if="!teskDetail.analysis">
          <div class="timeLock" :class="{ 'p-r32': isXue }">
            {{ time }}
          </div>
        </template>
        <!-- 只有病例练习试卷可收藏 -->
        <template
          #collect
          v-if="teskDetail.exerciseType == 'MEDICASE' && !isXue"
        >
          <div class="collectBtn" @click.stop="getCollect">
            <van-icon v-show="!collectBl" name="star-o" />
            <van-icon v-show="collectBl" name="star" />
            <span>&nbsp;收藏本题</span>
          </div>
        </template>
        <!-- app 中病例练习可分享 -->
        <template
          v-slot:shareBtn
          v-if="isApp && teskDetail.exerciseType == 'MEDICASE' && !isXue"
        >
          <div class="shareWrapper" @click.stop="shareFn">
            <div class="shareBtn"></div>
          </div>
        </template>
      </Header>
      <!-- 题目信息 -->
      <Question
        :teskDetail="teskDetail"
        @selectFn="selectFn"
        @fillFn="fillFn"
        v-show="loaded"
        @toApp="toApp"
        :access="access"
        :extinfo="{
          typeId: 'h5',
          url: shareInfo.url
        }"
      ></Question>

      <div class="submitContainer" v-show="loaded">
        <div class="submitWrapper" v-if="isLogin">
          <div class="btn prevBtn" @click.stop="getPrevious()">
            <span
              :class="{
                'icon-left-gray': teskDetail.position <= 1,
                'icon-left-orange': teskDetail.position > 1
              }"
            ></span>
            <span
              :class="{
                grayColor: teskDetail.position <= 1,
                themeColor: teskDetail.position > 1
              }"
              >上一页</span
            >
          </div>
          <div
            class="submitBtn"
            @click.stop="submitTesk"
            :class="{ canSubmit: btnStatus == 'done' }"
          >
            {{ btnStatus == 'submit' ? '已提交' : '提交' }}
          </div>
          <div
            class="btn nextBtn"
            @click.stop="goNext(teskDetail.quizId)"
            v-show="teskDetail.position != teskDetail.total"
          >
            <span
              :class="{
                grayColor: btnStatus != 'submit',
                themeColor: btnStatus == 'submit'
              }"
              >下一页</span
            >
            <span
              :class="{
                'icon-right-gray': btnStatus != 'submit',
                'icon-right-orange': btnStatus == 'submit'
              }"
            ></span>
          </div>
          <div
            class="btn nextBtn"
            @click.stop="getResult(teskDetail.quizId)"
            v-show="teskDetail.position == teskDetail.total"
          >
            <span
              :class="{
                grayColor: btnStatus != 'submit',
                themeColor: btnStatus == 'submit'
              }"
              >练习成果</span
            >
            <span
              :class="{
                'icon-right-gray': btnStatus != 'submit',
                'icon-right-orange': btnStatus == 'submit'
              }"
            ></span>
          </div>
        </div>
        <div class="toLogin submitWrapper" v-else>
          <div class="loginBtn" @click.stop="userLogin">我也要练习</div>
        </div>
      </div>
      <div
        class="tipBtn themeColor"
        @click.stop="showIdea"
        v-show="teskDetail.questionType == 'TEXT' && !teskDetail.analysis"
      >
        思路点播
      </div>
      <div class="rightTip" v-show="greatShow">
        <img src="@/assets/img/question/great.png" alt="" />
      </div>
      <!-- 未购买、未领取用户  -->
      <UserRole
        :role="role"
        :depId="teskDetail.departmentId"
        v-if="role == 'GUEST' && !isApp && isLogin"
        @getCheck="getCheck"
        :skuId="skuId"
      ></UserRole>
    </template>
    <!-- 该病例练习已下线 -->
    <div class="unline" v-else>
      <div class="imgBox">
        <img src="@/assets/img/common/empty2.png" alt="" />
      </div>
      <p class="tipMsg grayColor">该病例已下线～</p>
      <div class="msg" v-if="!isApp">
        别担心，打开好医术APP <br />丰富的病例 助你每日精进
      </div>
      <div class="btn" v-if="!isApp" @click.stop="toApp">打开App</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { exerReq } from '@/api/index'
import { paperFav, cancelPaperFav, getShareQuizDetail } from '@api/exercise'
import Header from '@/components/common/Header.vue'
import Question from '@com/list/Question2.vue'
import UserRole from '@com/exercise/userRole'
import {
  appPort,
  appShare,
  jumpModuleApp,
  hiddenAppNavBar,
  userLogin,
  iOSPort,
  androidPort,
  prevPageView,
  closeWebView,
  isLogin,
  weixinShare,
  callAppView,
  wechatPort,
  validateXue,
  closeAppView
} from '@/widget/index'
import { hostPath } from '@utils/basePath'

export default defineComponent({
  data() {
    return {
      teskDetail: {},
      answerDetail: {},
      collectBl: false,
      timer: null,
      time: '00:00',
      greatShow: false,
      timeOut: null,
      answer: {},
      isApp: appPort(),
      courseInfo: {
        practice_ID: '',
        practice_name: '',
        course_ID: '',
        course_name: ''
      },
      shareInfo: {
        title: '',
        desc: '丰富的病例，助您每日精进',
        url: hostPath + `/learn/detail/exercise/${this.$route.params.id}`,
        image: 'https://img-a.haoyishu.com/images/share/hys_logo.png'
      },
      depId: '',
      sourceObj: {
        1: '200100001',
        2: '200200001',
        9: '200300001',
        11: '200400001'
      },
      depObj: {
        1: '骨科',
        2: '心血管',
        9: '整形外科',
        11: '口腔外科',
        13: '肿瘤科'
      },
      module: '',
      bookmarkId: null, // 收藏
      favour: this.$route.query.favour === 'true', // app 收藏页进入该页面
      sourceInfo: this.$route.query.sourceInfo === 'recommend', // app 推荐页进入该页面
      taskId: this.$route.query.taskId || '',
      questionId: this.$route.query.questionId || '',
      paperId: this.$route.params.id,
      position: 1, // 当前做题位置
      loaded: false, // 页面数据是否加载完成
      btnStatus: 'undone', // undone 未做 done 做了未提交 submit 已提交
      role: '', // 用户角色
      isLogin: isLogin,
      online: true, // 病例是否上线中
      skuId: 0, // 创建订单 sku
      access: false, // 用户是否有权限做题
      isXue: validateXue()
    }
  },
  methods: {
    downTime() {
      var t = this.teskDetail.expectation
      if (t <= 0) {
        this.time = '00:00'
        return
      }
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.time = `${this.adjust(parseInt(t / 60) % 60)}:${this.adjust(t % 60)}`
      this.timer = setInterval(() => {
        t--
        if (t <= 0) {
          if (this.timer) clearInterval(this.timer)
          this.time = '00:00'
          return
        }
        this.time = `${this.adjust(parseInt(t / 60) % 60)}:${this.adjust(
          t % 60
        )}`
      }, 1000)
    },
    adjust(n) {
      return n > 9 ? n + '' : '0' + n
    },
    backFn() {
      this.$dialog
        .confirm({
          title: '确定退出练习？',
          message: '还未完成练习，将为你自动保留'
        })
        .then(() => {
          if (this.isXue) {
            closeAppView()
            return
          }
          if (this.favour || this.sourceInfo) {
            closeWebView()
          } else if (this.teskDetail.exerciseType === 'MEDICASE') {
            history.go(-1)
          } else {
            // prevPageView()
            closeWebView()
          }
        })
    },
    showIdea() {
      this.$dialog.alert({
        title: '解析(仅供参考)',
        messageAlign: 'left',
        message: this.teskDetail.hint,
        confirmButtonText: '有思路了'
      })
    },
    getCheck() {
      if (!/(detailExercise)/.test(this.$route.name)) {
        return
      }
      this.$showLoading()
      exerReq
        .getCheck({
          taskId: this.$route.query.taskId,
          paperId: this.paperId
        })
        .then(res => {
          this.$hideLoading()
          if (res.code === 200) {
            this.checkDate = res.data
            this.role = res.data.role
            this.skuId = res.data.skuId
            let exerciseType = res.data.exerciseType
            if (
              !/^(MEMBER|TRIAL)$/.test(this.role) &&
              this.checkDate.status === 'FINISHED' &&
              !/^(OMO|TEAM)$/.test(exerciseType)
            ) {
              // 不是会员习题已做完
              this.$router.replace({
                name: 'guideExam',
                query: {
                  depId: this.depId,
                  ...this.$route.query
                }
              })
              return
            }
            if (res.data.line === 'OFFLINE') {
              // 已下线
              this.online = false
              return
            }
            if (/^(MEMBER_EXPIRED|TRIAL_EXPIRED)$/.test(this.role)) {
              this.$dialog
                .alert({
                  message: '您的病例练习VIP会员已过期',
                  confirmButtonText: '去续费'
                })
                .then(() => {
                  this.$router.replace({
                    name: 'guideExam',
                    query: {
                      depId: this.depId,
                      ...this.$route.query
                    }
                  })
                })
            }
            // 是否有权限做题
            this.quizId = res.data.quizId
            // if (/^(OMO|TEAM)$/.test(exerciseType)) {
            //   this.access = true;
            // }
            if (
              /^(MEMBER|TRIAL)$/.test(this.role) ||
              /^(OMO|TEAM)$/.test(exerciseType)
            ) {
              this.access = true
            } else if (res.data.question) {
              this.access = false
              // 没有权限做题从check接口中获取题目信息
              this.teskDetail = res.data.question
              this.teskDetail.departmentId = res.data.departmentId
              this.setInfo(this.teskDetail)
              this.loaded = true
              return
            }
            if (this.checkDate.status === 'NOT_STARTED') {
              // 试卷未开始做
              this.getStart()
            } else if (this.checkDate.status === 'STARTED') {
              // 试卷已经做了一部分
              this.getTesk(this.checkDate.quizId || this.$route.query.quizId)
            } else if (this.$route.query.isStart) {
              // 重新练习
              this.getStart()
            } else if (this.checkDate.status === 'STARTED') {
              this.getTesk(this.checkDate.quizId || this.$route.query.quizId)
            } else if (this.checkDate.status === 'FINISHED') {
              if (this.$route.query.isStart) {
                this.getStart()
              } else {
                this.quizId = res.data.quizId
                let query = Object.assign({}, this.$route.query, {
                  quizId: this.quizId,
                  exerciseId: this.teskDetail.exerciseId || ''
                })
                const id = this.$route.params.id
                this.$router.replace({
                  path: `/detail/exercise/result/${id}`,
                  query
                })
              }
            } else {
              if (
                /^(MEMBER|TRIAL)$/.test(this.role) ||
                /^(OMO|TEAM)$/.test(exerciseType)
              ) {
                this.btnStatus = 'submit'
                this.getResult(this.checkDate.quizId)
              }
            }
          } else {
            this.$toast(res.message)
          }
        })
    },
    getResult(val) {
      if (this.btnStatus !== 'submit') {
        this.$toast('完成做题后查看结果')
        return
      }
      // 进入结果页
      const id = this.$route.params.id
      let query = JSON.parse(JSON.stringify(this.$route.query))
      delete query.quizId
      Object.assign(query, {
        quizId: val || this.quizId,
        exerciseId: this.teskDetail.exerciseId || ''
      })
      this.$router.replace({
        path: `/detail/exercise/result/${id}`,
        query
      })
    },
    getStart() {
      // 开始做练习
      this.$showLoading()
      this.isStart = this.$route.query.isStart
      if (this.isStart === '1') {
        this.starTaskId = this.$route.query.taskId
        this.startPaperId = this.$route.params.id
      } else {
        this.starTaskId = this.$route.query.taskId
        this.startPaperId = this.$route.params.id
      }
      exerReq
        .getStart({
          taskId: this.starTaskId,
          paperId: this.startPaperId
        })
        .then(res => {
          this.loaded = true
          this.$hideLoading()
          if (Number(res.code) === 200) {
            this.teskDetail = res.data
            this.bookmarkId = res.data.bookmarkId
            if (this.bookmarkId) this.collectBl = true
            this.setInfo(res.data)
            if (isLogin) {
              this.downTime()
            }
          } else if (Number(res.code) === 513) {
            // 已经开始做题
            this.getTesk(this.quizId)
          } else if (Number(res.code) === 514) {
            this.getResult()
          } else if (Number(res.code) === 515) {
            userLogin()
          } else if (Number(res.code) === 516) {
            if (this.checkDate.exerciseType === 'MEDICASE') {
              this.getShareDetail()
            } else {
              if (this.isApp) {
                jumpModuleApp({
                  typeId: 'smart_exercise_detail'
                })
              } else {
                this.$router.replace({
                  name: 'guideExam',
                  query: {
                    depId: this.depId,
                    ...this.$route.query
                  }
                })
              }
            }
          } else if (res.code === 521 || res.code === 519) {
            // 没有购买，无法作答
            if (this.checkDate.exerciseType === 'MEDICASE') {
              this.getShareDetail()
            } else {
              let query = this.getQuery()
              this.$router.replace({
                name: 'medicaseHome',
                query
              })
            }
          } else {
            this.$hideLoading()
            this.$toast(res.message)
          }
        })
    },
    getQuery() {
      let query = {}
      let depId = this.depId || this.$route.query.depId
      let sourceId = this.$route.query.sourceId
      query.depId = depId
      if (sourceId) {
        query.sourceId = sourceId
      }
      return query
    },
    goNext(val) {
      if (this.btnStatus !== 'submit') {
        this.$toast('提交后查看下一页')
        return
      }
      if (this.teskDetail.nextAnswered === true) {
        // 下一题是否作答
        this.getPrevious('back')
      } else {
        this.getTesk(val)
      }
    },
    getTesk(val) {
      // 下一题未答
      this.$showLoading()
      exerReq
        .getTask({
          quizId: val
        })
        .then(res => {
          this.loaded = true
          if (Number(res.code) === 200) {
            this.bookmarkId = res.data.bookmarkId
            if (this.bookmarkId) this.collectBl = true
            this.teskDetail = res.data
            this.$hideLoading()
            this.downTime()
            this.setInfo(res.data)
            this.backTop()
            this.btnStatus = 'undone'
          } else if (Number(res.code) === 514) {
            this.getResult(val)
          } else if (res.code === 519) {
            if (this.checkDate.exerciseType === 'MEDICASE') {
              this.getShareDetail()
            } else {
              let query = this.getQuery()
              this.$router.replace({
                name: 'medicaseHome',
                query
              })
            }
          } else {
            this.$hideLoading()
            this.$toast(res.message)
          }
        })
    },
    getPrevious(val) {
      // 已做答的题，选择上一题下一题
      this.$showLoading()
      if (this.teskDetail.quizId) {
        this.quizId = this.teskDetail.quizId
      } else {
        this.quizId = this.$route.query.quizId
      }
      let position = this.teskDetail.position
      if (val === 'back') {
        position = parseInt(this.teskDetail.position + 1)
      } else {
        if (this.teskDetail.quizId) {
          position = parseInt(this.teskDetail.position - 1)
        } else {
          position = parseInt(this.$route.query.position)
        }
        if (this.teskDetail.position === 1) {
          this.$hideLoading()
          this.$toast('当前已是第一题')
          return
        }
      }
      exerReq
        .getPrevious({
          quizId: this.quizId,
          position: position
        })
        .then(res => {
          if (res.code === 200) {
            this.$hideLoading()
            this.setInfo(res.data)
            this.backTop()
            this.teskDetail = res.data
            this.loaded = true
            this.access = true
            this.bookmarkId = res.data.bookmarkId
            this.taskId = res.data.taskId
            // 是否收藏
            if (this.bookmarkId) this.collectBl = true
            this.isAnalysis = false
            this.btnStatus = 'submit'
          } else {
            this.$hideLoading()
            this.$toast(res.message)
          }
        })
    },
    getCollect() {
      // 收藏
      if (this.collectBl) {
        // 取消收藏
        this.$showLoading()
        cancelPaperFav({
          bookmarkId: this.bookmarkId
        }).then(res => {
          this.$hideLoading()
          if (res.code === 200) {
            this.$toast('取消收藏成功')
            this.collectBl = false
          } else {
            this.$toast(res.message)
          }
        })
      } else {
        this.$showLoading()
        paperFav({
          paperId: this.paperId,
          taskId: this.taskId
        }).then(res => {
          this.$hideLoading()
          if (res.code === 200) {
            this.bookmarkId = res.data.bookmarkId
            this.collectBl = true
            this.$toast('收藏成功')
          } else {
            this.$toast(res.message)
          }
        })
      }
    },
    getRemoveCollect() {
      exerReq
        .getRemoveCollect({
          wrongId: this.wrongId
        })
        .then(res => {
          if (Number(res.code) === 200) {
            this.$toast(res.message)
          } else {
            this.$toast(res.message)
          }
        })
    },
    submitTesk() {
      if (this.btnStatus === 'submit') {
        return
      } else if (this.btnStatus !== 'done') {
        this.$toast('请作答后提交')
        return
      }

      this.$showLoading()
      exerReq
        .getAnswer({
          quizId: this.teskDetail.quizId,
          questionId: this.teskDetail.questionId,
          serial: this.teskDetail.serial,
          answer: this.answer
        })
        .then(res => {
          this.$hideLoading()
          if (Number(res.code) === 200) {
            clearInterval(this.timer)
            this.timer = null
            var checkTaskData = res.data
            var isRights = true
            this.btnStatus = 'submit'
            for (var key in checkTaskData.answer) {
              if (checkTaskData.answer[key] !== checkTaskData.userAnswer[key]) {
                isRights = false
              }
            }
            var self = this
            if (isRights) {
              this.greatShow = true
              this.timeOut && clearTimeout(this.timeOut)
              this.timeOut = null
              this.timeOut = setTimeout(() => {
                self.greatShow = false
              }, 800)
              self.teskDetail = res.data
            } else {
              self.greatShow = false
              self.teskDetail = res.data
            }
          } else {
            this.$toast(res.message)
          }
        })
    },
    selectFn(a) {
      for (var key in a) {
        if (a[key]) {
          this.btnStatus = 'done'
          break
        } else {
          this.btnStatus = 'undone'
        }
      }
      this.answer = a
    },
    fillFn(value) {
      if (value) {
        if (this.btnStatus !== 'submit') {
          this.btnStatus = 'done'
        }
        this.answer = JSON.parse(JSON.stringify(value))
      } else {
        this.btnStatus = 'undone'
      }
    },
    shareFn() {
      appShare(this.shareInfo)
      this.setGio(
        'click_sharing_practiceDetail',
        this.depObj[this.depId] || '',
        this.courseInfo,
        this.module
      )
    },
    setGio(type, dep, obj, module) {
      if (!obj.practice_ID) {
        return
      }
      let info = Object.assign({}, obj, {
        platform: this.portInfo(),
        departmentType: dep,
        moduleType: this.getModule(module),
        practicePageType: '答题详情页'
      })
      // obj practice_ID
      // course_ID
      // course_name
      // moduleType
      if (window.gio) {
        // ViewPracticeDetail
        // click_sharing_practiceDetail
        gio('track', type, info)
      }
    },
    portInfo() {
      if (appPort()) {
        if (iOSPort()) {
          return 'iOS'
        } else if (androidPort()) {
          return '安卓'
        }
      } else {
        return 'H5'
      }
    },
    getModule(type) {
      let str = ''
      switch (type) {
        case 'OMO':
          str = 'OMO'
          break
        case 'TEAM':
          str = 'online'
          break
        case 'INDIVIDUAL':
          str = 'AIexercise'
          break
      }
      return str
    },
    setInfo(data) {
      if (!this.depId) {
        let depId = data.departmentId
        this.depId = depId
        // 埋点设置
        this.courseInfo.practice_ID = data.paperId
        this.courseInfo.practice_name = data.paperName || data.exerciseName
        this.courseInfo.course_ID = data.exerciseId
        this.courseInfo.course_name = data.exerciseName
        this.module = data.exerciseType
        this.setGio(
          'ViewPracticeDetail',
          this.depObj[depId],
          this.courseInfo,
          data.exerciseType
        )
        // 分享设置
        let questionId = data.questionId
        this.questionId = questionId
        this.gettaskId = data.taskId
        this.shareInfo.title = `邀请你一起体验《${this.courseInfo.practice_name}》`
        data.cover && (this.shareInfo.image = data.cover)
        this.shareInfo.url += `?depId=${depId}&sourceId=${
          this.sourceObj[depId]
        }&questionId=${questionId}&taskId=${
          this.$route.query.taskId || data.taskId
        }`
        this.wxShare()
      }
    },
    wxShare() {
      weixinShare(this.shareInfo)
    },
    backTop() {
      // 回到顶部
      const realFunc = () => {
        let oTop = document.scrollingElement.scrollTop
        if (oTop > 0) {
          document.scrollingElement.scrollTop = oTop - 400
          this.backTopTimer = requestAnimationFrame(realFunc)
        } else {
          window.cancelAnimationFrame(this.backTopTimer)
        }
      }
      this.backTopTimer = window.requestAnimationFrame(realFunc)
    },
    userLogin() {
      // 去登录
      userLogin()
    },
    toApp() {
      // 打开 app
      if (wechatPort()) {
        this.$toast('请在复制链接在手机浏览器中打开')
        return
      }
      callAppView({
        url: this.shareInfo.url
      })
    },
    getShareDetail() {
      this.$showLoading()
      getShareQuizDetail({
        questionId: this.questionId,
        paperId: this.paperId,
        taskId: this.taskId
      }).then(res => {
        this.$hideLoading()
        if (res.code === 200) {
          let r = JSON.parse(JSON.stringify(res.data))
          delete r.answer
          delete r.analysis
          r.ratio = null
          this.teskDetail = r
          this.loaded = true
          this.setInfo(r)
          this.processRatio =
            (parseInt(this.teskDetail.position) /
              parseInt(this.teskDetail.total)) *
            100
        } else {
          this.$toast(res.message)
        }
      })
    }
  },
  mounted() {
    if (this.isApp) {
      hiddenAppNavBar()
    }
    this.previous = this.$route.query.previous
    this.isStart = this.$route.query.isStart
    this.paperId = this.$route.params.id
    if (this.previous === '1') {
      this.getPrevious()
    } else {
      if (isLogin) {
        this.getCheck()
      } else {
        this.getShareDetail()
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.timer)
    this.timer = null
  },
  components: {
    Header,
    Question,
    UserRole
  }
})
</script>

<style lang="scss" scoped>
a.full {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.timeLock {
  height: 58px;
  font-size: 50px;
  line-height: 58px;
  font-family: DINEngschrift;
  margin-left: 40px;
}
.shareWrapper {
  height: 88px;
  display: flex;
  align-items: center;
  padding-left: 14px;
  padding-right: 30px;
  overflow: hidden;
  margin-left: 68px;
  .shareBtn {
    height: 36px;
    width: 36px;
    background: url('~@/assets/icon/icon_share.png') no-repeat center;
    background-size: 100% 100%;
  }
}
.exerciseDetail {
  min-height: 100vh;
  .collectBtn {
    margin-right: 20px;
    padding: 10px 10px 10px 18px;
    color: #222;
    .van-icon-star,
    .van-icon-star-o {
      font-size: 38px;
      font-weight: bold;
    }
    .van-icon-star {
      color: $themeColor;
    }
    span {
      font-size: 28px;
      line-height: 88px;
    }
  }
}
.questBook {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 32px 12px;
  height: 66px;
  line-height: 66px;
  background: linear-gradient(90deg, #ffe3ce 0%, #fff8f3 100%);
  .questBook-l {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #212224;
  }
  .questBook-r {
    font-size: 32px;
    font-family: Helvetica;
    color: #212224;
  }
}
.submitContainer {
  width: 750px;
  height: 128px;
  margin: 0 auto;
  font-size: 32px;
  .submitWrapper {
    height: 128px;
    width: 750px;
    box-sizing: border-box;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    margin-left: -375px;
    background: #fff;
    box-shadow: 0 1px rgba(177, 177, 179, 0.25) inset;
    z-index: 999;
  }
  .loginBtn {
    width: 686px;
    height: 88px;
    background: #ff6600;
    box-shadow: 0px 4px 8px 0px rgba(255, 102, 0, 0.2);
    border-radius: 56px;
    text-align: center;
    line-height: 88px;
    color: #fff;
  }
  .btn {
    width: 180px;
    height: 128px;
    font-size: 28px;
    display: flex;
    align-items: center;
    line-height: 1;
    justify-content: center;
    span {
      padding-right: 0.1rem;
      font-weight: 600;
    }
  }
  // .prevBtn {
  //   background: #f5f5f7;
  // }
  // .nextBtn,
  // .submitBtn {
  //   width: 220px;
  //   opacity: 0.5;
  //   border-radius: 44px;
  //   background: #ff6600;
  //   color: #fff;
  // }
  .submitBtn {
    height: 88px;
    width: 220px;
    opacity: 0.5;
    line-height: 88px;
    border-radius: 44px;
    background: #ff6600;
    font-size: 32px;
    color: #fff;
    text-align: center;
    font-weight: bold;
  }
  .canSubmit {
    opacity: 1;
  }
}
.tipBtn {
  width: 188px;
  height: 76px;
  background: url('~@/assets/icon/question/tip_idea.png') no-repeat center;
  background-size: 188px 76px;
  position: fixed;
  bottom: 208px;
  left: 50%;
  margin-left: 750 - 188 - 375px;
  text-align: center;
  line-height: 76px;
  font-size: 24px;
  z-index: 666;
}
.rightTip {
  width: 240px;
  height: 120px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -60px;
  margin-left: -120px;
  animation: zoomIn 0.2s linear;
  z-index: 999;
  img {
    width: 100%;
  }
}
.grayColor {
  color: #b1b1b3;
}
.unline {
  width: 7.5rem;
  margin: 0 auto;
  padding-top: 3rem;
  text-align: center;
  .imgBox {
    width: 400px;
    height: 298px;
    margin: 0 auto;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .tipMsg {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 40px;
    margin: 8px auto 32px;
  }
  .msg {
    line-height: 50px;
    font-size: 36px;
    margin-bottom: 64px;
    font-weight: 600;
  }
  .btn {
    width: 408px;
    height: 88px;
    background: #ff6600;
    border-radius: 44px;
    text-align: center;
    line-height: 88px;
    color: #fff;
    font-size: 32px;
    margin: 0 auto;
  }
}
</style>
